import axios from 'axios';
import Api from './Api';
import { post, put } from './Api';

const endpoint = 'clients';
export const create = async (data) => await post(`${endpoint}`, data);
export const update = async (data) => await put(`${endpoint}`, data);

class ClientsApi extends Api {
  constructor() {
    super('client', 'clients');
  }

  async softDelete(clientId) {
    const errorText = 'Could not delete client';
    let res = null;
    try {
      res = await axios.get(`/clients/soft_delete/${clientId}`);
      if (res.status === 200) {
        if (res.data.err) {
          return {
            err: true,
            errDesc: res.data.err_desc,
          };
        }
        res = res.data;
      } else {
        console.error(errorText);
      }
    } catch (e) {
      console.error(errorText);
      console.error(e);
      res = null;
    }
    return res;
  }
}
const clientsApi = new ClientsApi();

export default clientsApi;
